import EmptyState from "ds/components/EmptyState";
import { EmptystateWebhooksColored } from "components/icons/generated";
import Box from "ds/components/Box";

const AuditTrailConfigEmpty = () => {
  return (
    <Box align="center" justify="center" grow="1">
      <EmptyState
        title="Audit trail is not configured"
        icon={EmptystateWebhooksColored}
        caption="Set up a webhook endpoint to start receiving audit trail events."
      />
    </Box>
  );
};

export default AuditTrailConfigEmpty;
